<template>
  <thumbnails-range
    ref="thumbnails"
    class="thumbnails-range"
    :thumbnails="thumbnails"
    :thumbnail-size="thumbnailSize"
  />
</template>

<script>
import ThumbnailsRange from "@/components/timeline/thumbnails/ThumbnailsRange.vue";
import { mapGetters } from "vuex";

// @group Timeline
// Render thumbnails in specified time range
export default {
  name: "TimelineThumbnails",
  components: {
    ThumbnailsRange
  },
  props: {
    /** start & end time of rendering thumbnails */
    timerange: {
      type: Array,
      required: true,
      validator([start, end]) {
        return start < end;
      }
    },
    /** time between two rendering thumbnails in seconds  */
    timestep: {
      type: Number,
      default: 60,
      validator(step) {
        return step >= 1;
      }
    },
    /** thumbnail width & height in pixels */
    thumbnailSize: {
      type: Object,
      default() {
        return {
          w: 270,
          h: 155
        };
      }
    }
  },
  computed: {
    ...mapGetters("thumbnails", ["getThumbnailLink"]),
    // @vuese
    // Frame start timestamp
    start() {
      return this.timerange[0];
    },
    // @vuese
    // Frame end timestamp
    end() {
      return this.timerange[1];
    },
    // @vuese
    // Frame duration in seconds
    duration() {
      return this.end - this.start;
    },
    // @vuese
    // Array of timestamp for loading thumbnails
    thumbnailsTimestamps() {
      const timestamps = [];
      for (let ts = this.start; ts <= this.end; ts += this.timestep) {
        timestamps.push(ts);
      }
      return timestamps;
      // return getRange(this.start, this.end, this.timestep);
    },
    // @vuese
    // List of thumbnail links
    thumbnails() {
      return this.thumbnailsTimestamps.map(this.getThumbnailLink);
    }
  }
};
</script>

<style lang="scss" scoped>
.thumbnails-range {
  overflow: hidden;
}
</style>
